// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-20742123] .primary .modal-body{background-color:#eaeaff}[data-v-20742123] .indigo .modal-body{background-color:#eaf0ff}[data-v-20742123] .select-account-radio-button.custom-radio .custom-control-input~.custom-control-label{height:auto}[data-v-20742123] .copy-link-button .input-group-text{background-color:#5a47d7}.copy-link[data-v-20742123]{font-size:small}.trial-link-expiry[data-v-20742123]{color:#847fe9}", ""]);
// Exports
module.exports = exports;
